// extracted by mini-css-extract-plugin
module.exports = {"subpageContainer":"StudentsNewGrads-module--subpageContainer--3-Bg0"};